import httpClient from "./httpClient";

const prefix = "/branch-schedule-weekend";

/** Coincide con ScheduleItemDto del API; el resto (p. ej. branchScheduleId) rompe forbidNonWhitelisted. */
const WEEKEND_SCHEDULE_ITEM_KEYS = [
  "positionId",
  "positionName",
  "positionDisplayName",
  "shift",
  "day",
  "partnerId",
  "freeDayId",
] as const;

function sanitizeWeekendScheduleItems(items: any[] | undefined): any[] {
  if (!items?.length) return [];
  return items.map((it) => {
    const out: Record<string, unknown> = {};
    for (const k of WEEKEND_SCHEDULE_ITEM_KEYS) {
      if (it != null && it[k] !== undefined) {
        out[k] = it[k];
      }
    }
    return out;
  });
}

export async function saveBranchScheduleWeekend(data: any) {
  const payload = {
    ...data,
    items: sanitizeWeekendScheduleItems(data?.items),
  };
  return (await httpClient.post(`${prefix}`, payload)).data;
}

export async function findBranchScheduleWeekendByBranchAndWeek(branchId: number, weekValue: string) {
  return (await httpClient.get(`${prefix}/by-branch-week?branchId=${branchId}&weekValue=${weekValue}`)).data;
}

export async function findAllBranchScheduleWeekend() {
  return (await httpClient.get(`${prefix}`)).data;
}

export async function findBranchScheduleWeekendById(id: number) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function updateBranchScheduleWeekend(id: number, data: any) {
  const payload =
    data?.items != null
      ? { ...data, items: sanitizeWeekendScheduleItems(data.items) }
      : data;
  return (await httpClient.patch(`${prefix}/${id}`, payload)).data;
}

export async function deleteBranchScheduleWeekend(id: number) {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}

